import { clsx } from 'clsx'
import { useMemo, type FC } from 'react'
import { useColorScheme } from 'react-native'
import { useMarkdown, type useMarkdownHookOptions } from 'react-native-marked'

import { VStack, type VStackProps } from '@/components'

export interface MarkdownProps extends Omit<VStackProps, 'children'> {
  children: string
}

export const Markdown: FC<MarkdownProps> = ({ className, children, ...props }) => {
  const colorScheme = useColorScheme()

  const elements = useMarkdown(
    children,
    useMemo<useMarkdownHookOptions>(
      () => ({
        colorScheme,
        theme: {
          colors: {
            code: '#000000',
            link: '#2563eb',
            text: '#000000',
            border: '#d0d7de'
          },
          spacing: {
            xs: 2,
            s: 4,
            m: 8,
            l: 16
          }
        },
        styles: {
          text: {
            fontFamily: 'Poppins_400Regular',
            fontSize: 16
          },
          link: {
            fontFamily: 'Poppins_500Medium',
            textDecorationLine: 'underline'
          },
          paragraph: {
            marginTop: 0,
            marginBottom: 0,
            paddingVertical: 0
          },
          h1: {
            fontFamily: 'Poppins_600SemiBold',
            textDecorationLine: 'none'
          }
        }
      }),
      [colorScheme]
    )
  )

  return (
    <VStack
      className={clsx('gap-2', className)}
      {...props}
    >
      {elements}
    </VStack>
  )
}
